import React from 'react';

import { ISuccessDescriptionProps } from './types/success-description-props.interface';

import * as S from './SuccessDescription.styled';

export const SuccessDescription: React.FC<ISuccessDescriptionProps> = ({ variant, t }) => {
  switch (variant) {
    case 'password-reset':
      return (
        <S.DescriptionTextCentered>{t('passwordReset.successText#1')}</S.DescriptionTextCentered>
      );
    case 'registration':
      return (
        <>
          <S.DescriptionText>{t('registration.successText#1')}</S.DescriptionText>
          <S.DescriptionText>{t('registration.successText#2')}</S.DescriptionText>
        </>
      );
  }
};
